import { useCallback } from 'react';

import { useTrackPlayedVideo } from '@air/analytics';

import { usePlayerStore } from '../components/PlayerContextProvider';

export const usePlayerPlay = () => {
  const id = usePlayerStore((state) => state.id);
  const videoElement = usePlayerStore((state) => state.videoElement);
  const { trackPlayedVideo } = useTrackPlayedVideo();

  const onPlayerPlay = useCallback(() => {
    if (videoElement) {
      videoElement.play();
      trackPlayedVideo({ id });
    }
  }, [videoElement, id, trackPlayedVideo]);

  return { onPlayerPlay };
};
